import { fetchResponse } from './api-helper';

const activeAlertsUrl = `${process.env.REACT_APP_GLOBAL_ALERTING_API}`;

export const getActiveAlerts = async () => {
  const impact = await fetchResponse(activeAlertsUrl);
  return impact.alerts;
};
